import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateRevenueAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.CreateRevenueAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedCreateRevenueAccountCommandV1: result.authorized,
		createRevenueAccountCommandV1: result.command,
		completedCreateRevenueAccountCommandV1: result.completed,
		errorCreateRevenueAccountCommandV1: result.error,
		invokeCreateRevenueAccountCommandV1: result.invoke,
		invokingCreateRevenueAccountCommandV1: result.invoking,
		succeedCreateRevenueAccountCommandV1: result.succeed,
		validationErrorsCreateRevenueAccountCommandV1: result.validationErrors,
		onSucceedCreateRevenueAccountCommandV1: result.onSucceed,
	}
}

export function useDeleteRevenueAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteRevenueAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteRevenueAccountCommandV1: result.authorized,
		deleteRevenueAccountCommandV1: result.command,
		completedDeleteRevenueAccountCommandV1: result.completed,
		errorDeleteRevenueAccountCommandV1: result.error,
		invokeDeleteRevenueAccountCommandV1: result.invoke,
		invokingDeleteRevenueAccountCommandV1: result.invoking,
		succeedDeleteRevenueAccountCommandV1: result.succeed,
		validationErrorsDeleteRevenueAccountCommandV1: result.validationErrors,
		onSucceedDeleteRevenueAccountCommandV1: result.onSucceed,
	}
}

export function useUpdateRevenueAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }

			return new c.UpdateRevenueAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value)
		})
	}

	return {
		...result,
		authorizedUpdateRevenueAccountCommandV1: result.authorized,
		updateRevenueAccountCommandV1: result.command,
		completedUpdateRevenueAccountCommandV1: result.completed,
		errorUpdateRevenueAccountCommandV1: result.error,
		invokeUpdateRevenueAccountCommandV1: result.invoke,
		invokingUpdateRevenueAccountCommandV1: result.invoking,
		succeedUpdateRevenueAccountCommandV1: result.succeed,
		validationErrorsUpdateRevenueAccountCommandV1: result.validationErrors,
		onSucceedUpdateRevenueAccountCommandV1: result.onSucceed,
	}
}

